module.exports = __webpack_public_path__ + "img/mastercard.dea05fa3.png";